module.exports = __webpack_public_path__ + "img/join_content_3.4e0171d7.png";